import { Link } from "react-router-dom";
import { InfoPage } from "@/components/InfoPage";
import { useT } from "@/lib/i18n";

export default function NotFoundPage() {
  const t = useT();
  return (
    <InfoPage testid="not-found-screen" title="Page not found" sections={[]}>
      <p className="terms-p">{t("That address doesn't match a page in Fuel Hauler Pro.")}</p>
      <Link className="primary-btn" to="/" data-testid="not-found-home">{t("Go to Check a tank")}</Link>
    </InfoPage>
  );
}
